import { useTranslation } from 'react-i18next';
import { AuthLayout } from '@/components/AuthLayout';
import ForgotPasswordForm from '@/widgets/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  const { t } = useTranslation('auth');
  return (
    <AuthLayout title={t('resetPassword')}>
      <ForgotPasswordForm />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
